import { Image, Spacer } from 'components/ui-kit';
import { Column, Container, Row } from 'components/ui-kit/grid';
import { type JSX } from 'react';
import styles from './quiz-idle.module.scss';
import { Box } from '../../components/box';
import { Button } from '../../components/button/button.component';

type TQuizViewIdleProps = {
  onStart: VoidFunction;
};
export const QuizViewIdle = ({ onStart }: TQuizViewIdleProps): JSX.Element => {
  return (
    <Container>
      <Box className={styles.wrapper}>
        <Row gap={{ s: 0, m: 16 }}>
          <Column span={{ s: 12 }} className={styles.contentWrapper}>
            <Row>
              <Column span={{ s: 10, m: 6 }}>
                <h1 className={styles.title}>
                  Чем похожи предприниматель и&nbsp;утконос?
                </h1>
              </Column>
            </Row>
          </Column>
          <Column span={{ s: 12, m: 0 }}>
            <Image
              className={styles.image}
              src="/images/collaborations/utkonos/main.svg"
              alt="Утконос"
            />
          </Column>
          <Column span={{ s: 12, m: 6, l: 5 }}>
            <div className={styles.content}>
              <p>
                Оба&nbsp;&mdash; настоящие примеры того, как важно меняться,
                менять и&nbsp;постоянно адаптироваться к&nbsp;изменениям.
              </p>
              <p>
                Да, в&nbsp;результате может получиться что-то
                необычное&nbsp;&mdash; например, млекопитающий зверёк
                с&nbsp;клювом и&nbsp;целой кладкой яиц. Но&nbsp;мы&nbsp;все
                разные&nbsp;&mdash; узнаем, какой вы&nbsp;утконос?
                И&nbsp;утконос ли&nbsp;вообще?
              </p>
              <p>Да, это комплимент!</p>
              <p>
                Сначала&nbsp;&mdash; короткий тест из&nbsp;5&nbsp;вопросов.
                А&nbsp;потом&nbsp;&mdash; новая коллекция с&nbsp;утконосом
                от&nbsp;Универмага!
              </p>
              <Spacer size={30} />
              <Button variant="primary" onClick={onStart}>
                Какой я утконос?
              </Button>
            </div>
          </Column>
        </Row>
      </Box>
    </Container>
  );
};
